export const PATH_SET = 'navigation.PATH_SET';
export const AFTER_TACK_PATH_SET = 'navigation.AFTER_TACK_PATH_SET';
export const AFTER_TACK_PATH_RESET = 'navigation.AFTER_TACK_PATH_RESET';



// WEBPACK FOOTER //
// ./src/stores/navigation/action_types.js